export default __webpack_public_path__ + "static/media/parts_logo.ebcc8e70.svg";